import type { VoucherBannerVariant } from '../../../../VoucherBanner.types'
import { StepIcon } from './VoucherStepIcon.styles'

const STEP_PATHS = [
  'M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM11 14H9V6H7V4H11V14Z',
  'M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM12 8C12 9.11 11.1 10 10 10H8V12H12V14H6V10C6 8.89 6.9 8 8 8H10V6H6V4H10C11.1 4 12 4.89 12 6V8Z',
  'M16 0H2C0.9 0 0 0.9 0 2V16C0 17.1 0.9 18 2 18H16C17.1 18 18 17.1 18 16V2C18 0.9 17.1 0 16 0ZM12 7.5C12 8.33 11.33 9 10.5 9C11.33 9 12 9.67 12 10.5V12C12 13.11 11.1 14 10 14H6V12H10V10H8V8H10V6H6V4H10C11.1 4 12 4.89 12 6V7.5Z'
]

interface VoucherStepIconProps {
  step: number
  variant: VoucherBannerVariant
}

const VoucherStepIcon = ({ step, variant }: VoucherStepIconProps) => (
  <StepIcon variant={variant} viewBox="0 0 18 18" fill="none" aria-hidden>
    <path d={STEP_PATHS[step - 1]} fill="currentColor" />
  </StepIcon>
)

export default VoucherStepIcon
